import React, { useState, useEffect } from "react";
import { Button } from "bootstrap-4-react/lib/components";
import { useLocation, useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import FilterProduct from "./filterProduct";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadProductCsvReport,
  getFilterProductsList,
  getProductConditionList,
  getProductStatusList,
  getProductWarehouseList,
  productBackDetails,
} from "../../../store/actions/incoming";
import BatchPagination from "../../batch/BatchPagination";
import { featureSubmodulePermission, numOfPage, orderManagement, permssionCreate, permssionEdit, permssionView, products, returnsManagement, shipmentModule, SUBF_PRODUCTLISTING } from "../../../constant";
import moment from "moment";
import LoaderSpinner from "../../common/Loader";
import { checkPermission, getStatusClass, renderTableRow } from "../../../config/utils";
import ViewImage from "../../common/ViewImage";
import _ from "lodash";
import ActionItems from "../../common/showActions";
import { Tooltip as WmsTooltip } from "react-tooltip";
import { addToCart } from "../../../store/actions";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { useSearchParams } from 'react-router-dom';
import AddTaskModal from "./AddTaskModal";
import { getProductDetailsService } from "../../../services/incoming.service";

const ProductList = (props) => {
  const navigate = useNavigate();
  const UserValue = useSelector((state) => state.auth.user);
  const productsList = useSelector(
    (state) => state.IncomingProductReducer?.productsList
  );
  const productsListPageInfo = useSelector(
    (state) => state.IncomingProductReducer?.productsListPageInfo
  );
  const productsListStatus = useSelector(
    (state) => state.IncomingProductReducer?.productsListStatus
  );
  const [params] = useSearchParams();

  const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);
  const productBackDetailsObj = useSelector((state) => state.IncomingReducer.productBackDetailsObj)
  const { cartItems } = useSelector((state) => state.shipment);
  const dispatch = useDispatch();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const landingSearch = location?.state?.searchTxt || null;
  const trackingNumber = location?.state?.trackingNumber || params.get('trackingNumber') || null;

  const packageDate = location?.state?.backDate || null;
  const _date = location?.state?.date || moment().format('MM-DD-YYYY');
  const [selectedRecord, setSelectedRecord] = useState({});
  const [showHideImageModal, setShowHideImageModal] = useState(false);
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);
  const [taskContext, setTaskContext] = useState(null);
  const [sellerList, setSellerList] = useState([]);
  const [allSellers, setAllSellers] = useState([]);
  const [allProduct, setAllProduct] = useState([]);

  let dataLoad = {
    pageIndex: 1,
    pageSize: 30,
    sortColumn: "",
    date: _date,
    searchKeywords: "",
    sellerIdList: [],
    companyIdList: [],
    showFilter: props.productType === "Product" ? true : false,
    searchTxt: '',
    sortOrder: 'DESCENDING',
    showSearch: true,
    companySellerId: 0,
    isSuperAdmin: UserValue?.Value?.isSuperAdmin,
    warehouseList: [],
    conditionList: [],
    processingDateTo: "",
    processingDateFrom: '',
    totalPages: 1,
    storageIdList: [],
    billingStatusList: [],
    returnProductType: [],
    productStatusId: [],
  }

  const [filterValue, setFilterValue] = useState({});

  useEffect(() => {
    if (!_.isEmpty(productBackDetailsObj) && props.productType === "Product") {
      setFilterValue({ ...filterValue, ...productBackDetailsObj });
    } else {
      setFilterValue({ ...dataLoad });
    }
  }, []);

  useEffect(() => {
    if (productsList?.length) {
      setAllProduct(productsList);
    }
  }, [productsList]);

  useEffect(() => {
    if (!_.isEmpty(filterValue)) {
      if (_date && moment(_date).isValid()) {
        fetchFilterProductList();
      } else if (location?.state?.trackingNumber) {
        fetchFilterProductList();
      } else if (location?.state?.searchTxt || location?.state?.searchTxt === "") {
        fetchFilterProductList("fromLandingPage");
      } else {
        navigate("/incoming-products");
      }
    }
  }, [filterValue.pageIndex, filterValue.pageSize, filterValue.sortColumn, filterValue.sortOrder, location?.state?.date]);

  useEffect(() => {
    if (productsListStatus === "pending") {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [productsListStatus]);

  const getBasePayload = () => ({
    pageIndex: filterValue.pageIndex,
    pageSize: filterValue.pageSize,
    sortColumn: filterValue.sortColumn,
    sortOrder: filterValue.sortOrder,
    userId: UserValue?.Value?.employeeId,
    companySellerId: UserValue?.Value?.companySellerId,
    isSuperAdmin: UserValue?.Value?.isSuperAdmin,
    warehouseList: _.map(filterValue.warehouseList, "id"),
    conditionList: _.map(filterValue.conditionList, "id"),
    sellerIdList: _.map(filterValue.sellerIdList, "id"),
    companyIdList: _.map(filterValue.companyIdList, "Id"),
    processingDateTo: null,
    processingDateFrom: null,
    productStatusId: _.map(filterValue.productStatusId, "id"),
  });

  const fetchFilterProductList = (type) => {
    if (props.productType !== "Product") {
      dispatch(
        getFilterProductsList({
          pageIndex: filterValue.pageIndex,
          pageSize: filterValue.pageSize,
          sortColumn: filterValue.sortColumn,
          sortOrder: filterValue.sortOrder,
          searchKeywords: filterValue.searchTxt.trim(),
          date: "",
        })
      );
      return;
    }

    const baseData = getBasePayload();

    // 🔹 From landing page
    if (type === "fromLandingPage") {
      dispatch(
        getFilterProductsList({
          ...baseData,
          date: _date,
          searchKeywords: landingSearch.trim() || "",
        })
      );
      return;
    }

    // Tracking number search
    if (trackingNumber) {
      const data = {
        ...baseData,
        date: null,
        searchKeywords: filterValue.searchTxt.trim(),
        trackingNumber,
      };

      dispatch(getFilterProductsList(data));
      setFilterValue({
        ...filterValue,
        date: null,
        searchKeywords: trackingNumber,
        searchTxt: trackingNumber,
      });
      return;
    }

    // Default product listing
    const storageIdList = filterValue?.StorageIdList?.map(item => item.value) || [];
    let date = null;

    if (!filterValue.filterApplied && location?.state?.date && filterValue.searchTxt === "") {
      date = moment(location.state.date).format("YYYY-MM-DDT00:00:00");
    }

    const data = {
      ...baseData,
      searchKeywords: filterValue.searchTxt.trim() || landingSearch,
      trackingNumber: "",
      storageIdList,
      billingStatusList: Array.isArray(filterValue.billingStatusList)
        ? filterValue.billingStatusList.map(item => item?.value || item)
        : [],
      processingDateFrom: filterValue.processingDateFrom,
      processingDateTo: filterValue.processingDateTo,
      date,
      productStatusId: _.map(filterValue.productStatusId, "id"),
    };

    if (filterValue.filterApplied && !filterValue.processingDateFrom && !filterValue.processingDateTo) {
      data.processingDateTo = moment().format("YYYY-MM-DDT00:00:00");
      data.processingDateFrom = moment().subtract(30, 'days').format("YYYY-MM-DDT00:00:00");
    }

    if (storageIdList.length) {
      data.date = null;
    }

    dispatch(getFilterProductsList(data));
  };


  useEffect(() => {
    window.scroll(0, 0);
    if (UserValue?.Value?.userName && props.productType === "Product") {
      dispatch(getProductConditionList());
      dispatch(getProductStatusList());
      dispatch(getProductWarehouseList());
    }
  }, [UserValue]);

  const handleEditRow = (item) => {
    let date = props?.productType === "Product" ? moment(_date).format("MM-DD-YYYY") : item.processingDate
    dispatch(productBackDetails(filterValue))
    navigate(`/incoming-product/fd-${date}-3pl/${item.id}`, {
      state: {
        view: false,
        date: date,
        landingSearch,
        trackingNumber,
        productType: props.productType
      },
    });
  };

  const handleViewRow = (item) => {
    let date = props?.productType === "Product" ? _date : item.processingDate
    dispatch(productBackDetails(filterValue))
    navigate(`/incoming-product/fd-${date}-3pl/${item.id}`, {
      state: {
        view: true,
        date: date,
        landingSearch,
        trackingNumber,
        productType: props.productType
      },
    });
  };

  const handleOpenCreateTaskForProduct = async (item) => {
    // The product listing payload does not always include companyId/sellerId.
    // Resolve them from the product detail so the CreateTask API receives
    // non-empty company/seller identifiers (otherwise the request fails).
    const baseContext = {
      sku: item.sku,
      productName: item.productName,
      availableQty: item.quantity,
      companyId: item.companyId,
      sellerId: item.sellerId,
      inboundProductId: item.inboundProductId,
      referenceId: item.id,
      referenceType: 'Product',
    };
    const hasIds = Number(item.companyId) > 0 && Number(item.sellerId) > 0;
    if (hasIds) {
      setTaskContext(baseContext);
      setShowAddTaskModal(true);
      return;
    }
    try {
      setLoader(true);
      const res = await getProductDetailsService(item.id);
      const entity = res?.data?.Entity || {};
      setTaskContext({
        ...baseContext,
        companyId: entity.companyId || item.companyId || 0,
        sellerId: entity.sellerId || item.sellerId || 0,
        inboundProductId: entity.inboundProductId || item.inboundProductId || 0,
      });
      setShowAddTaskModal(true);
    } catch (err) {
      console.error('Failed to fetch product details for Create Task:', err);
      toast.error('Unable to load product details for task creation.');
    } finally {
      setLoader(false);
    }
  };

  const handleSortingCoulmn = (event, sortColumn) => {
    event.preventDefault();
    let newSortOrder = filterValue.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    setFilterValue({
      ...filterValue,
      pageIndex: 1,
      sortColumn: sortColumn,
      sortOrder: newSortOrder,
    });
  };

  const resetPagination = () => {
    if (filterValue.pageIndex !== 1) {
      setFilterValue({ 
        ...filterValue, 
        pageIndex: 1, 
        filterApplied: false, 
        storageIdList: [], 
        StorageIdList: [], 
        date: _date, 
        billingStatusList: [],
        warehouseList: [],
        conditionList: [],
        processingDateFrom: '',
        processingDateTo: '',
        companyIdList: [],
        sellerIdList: [],
        searchKeywords: '',
        returnProductType: [],
        productStatusId: [],
      });
    } else {
      setFilterValue({ 
        ...filterValue, 
        filterApplied: false,
        storageIdList: [],
        StorageIdList: [],
        warehouseList: [],
        conditionList: [],
        processingDateFrom: '',
        processingDateTo: '',
        companyIdList: [],
        sellerIdList: [],
        billingStatusList: [],
        date: _date,
        searchKeywords: '',
        returnProductType: [],
        productStatusId: [],
      });
      let data = JSON.parse(JSON.stringify(dataLoad));
      data.showFilter = true;
      data.filterApplied = false;
      data.pageSize = filterValue.pageSize;
      props.productType === "allProducts" && (data.date = null);
      dispatch(getFilterProductsList(data));
    }
    setSellerList(allSellers);
  };

  const handleSearchFilter = (e, type) => {
    if (type === "clear") {
      handleResetSearch();
      return;
    }
    if (filterValue.pageIndex !== 1) {
      setFilterValue({ ...filterValue, pageIndex: 1, filterApplied: true });
    } else {
      setFilterValue({ ...filterValue, filterApplied: true });
      fetchFilterProductList();
    }
  };
  
  const handleResetSearch = () => {
    let data = props.productType === "Product" ? {
      ...dataLoad,
      pageSize: filterValue.pageSize
    } : {
      ...dataLoad,
      date: _date,
      pageSize: filterValue.pageSize,
      filterApplied: false,
    }
    setFilterValue({ ...data });
    dispatch(getFilterProductsList(data));
  }

  const handleEnterClick = (e) => {
    if (e.key === "Enter") {
      handleSearchFilter(e, "enter");
    }
  };

  const handleBlur = (e) => {
    const { value } = e.target;
    setFilterValue({ ...filterValue, searchTxt: value.trim() })
  };

  const handleSortingClass = (columnName, isArrow = false) => {
    if (isArrow) {
      return filterValue.sortColumn === columnName && filterValue.sortOrder === "ASCENDING" ? "fa fa-arrow-up" : "fa fa-arrow-down";
    }
    return filterValue.sortColumn === columnName ? 'active sortBtn' : 'sortColumn sortBtn'
  };

  const handlePackagePageNavigation = (item) => {
    navigate(`/incoming-packages/package-details`, {
      state: {
        trackingNumber: item.trackingNo,
        date: _date || location?.state?.backDate,
        backUrl: `/incoming-products/fd-${_date}-3pl`
      },
    });
  };

  const handlePackageBackDateNavigation = (packageDate) => {
    navigate(`/incoming-packages/fd-${packageDate}-3pl`, {
      state: {
        trackingNumber: '',
        date: location?.state?.backDate || _date
      },
    });
  }

  const handleBackNavigation = () => {
    if (trackingNumber && packageDate) {
      handlePackageBackDateNavigation(packageDate);
    } else if (packageDate) {
      handlePackagePageNavigation();
    } else {
      navigate("/incoming-products");
      dispatch(productBackDetails({}));
    }
  }

  const handleFilterToogle = (key, value) => {
    setFilterValue({ ...filterValue, [key]: value })
  }

  const renderContent = () => {
    if (props.productType !== "Product") {
      return <p></p>;
    }

    if (location?.state?.searchTxt || trackingNumber) {
      return <p className="packageDate"></p>;
    }

    return (
      <h5 className="mt-2">
        {moment(new Date(_date)).format("MM-DD-YYYY")}
      </h5>
    );
  };

  const handleAddToCartAction = (item) => {
    let items = _.cloneDeep(cartItems);
    let isExist = items.find((i) => i.id === item.id);
    if (!isExist) {
      let itemDetails = {
        ...item,
        MaxQuantity: item.quantity,
      };
      items.push(itemDetails);
      toast.success('Item Added in cart');
    } else {
      toast.info('Item already added in cart');
      return;
    }
    dispatch(addToCart(items));
  };

  const handleHistoryPage = (item) => {
    navigate(`/incoming-product/history-${item.id}`, {
      state: {
        data: item,
        editable: false,
        type: 'incoming',
        isReturn: true,
        productType: props.productType,
        date: _date,
      },
    })
  };

  const handleAllProductHistoryPage = (item) => {
    navigate(`/incoming-product-listing/history-${item.id}`, {
      state: {
        data: item,
        editable: false,
        type: 'incoming',
        isReturn: true,
        productType: props.productType,
      },
    })
  };

  const handleDownloadCsv = async () => {
    const data = {
      ...filterValue,
      searchKeywords: filterValue.searchTxt,
      warehouseList: _.map(filterValue.warehouseList, "id"),
      conditionList: _.map(filterValue.conditionList, "id"),
      sellerIdList: _.map(filterValue.sellerIdList, "id"),
      companyIdList: _.map(filterValue.companyIdList, "Id"),
      date: (filterValue.processingDateFrom || filterValue.processingDateTo) ? '' : location?.state?.date,
      storageIdList: filterValue?.StorageIdList?.map((item) => item.value) || [],
      billingStatusList: Array.isArray(filterValue.billingStatusList) ? _.map(filterValue.billingStatusList, item => item?.value || item) : [],
      productStatusId: _.map(filterValue.productStatusId, "id"),
    };
    data.filterApplied && (data.date = null);
    delete data.StorageIdList;
    data?.storageIdList?.length && delete data.date;
    setLoader(true);
    let downloadRes = await downloadProductCsvReport(data);
    if (downloadRes?.data?.Status === 200) {
      toast.success(downloadRes?.data?.Entity);
    } else {
      toast.error(downloadRes?.data?.Entity);
    }
    setLoader(false);
  };

  const handleCreateProduct = (e) => {
    navigate(`/incoming-product/create-product/${0}`,
        { state: { view: false, isCreated: true } })
  };

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec mb-1">
          <div>
            {props.productType === "Product" ? "Return Products Details View" : "Product Listing"}
            {!filterValue.filterApplied && renderContent()}
          </div>
          <div className="top_right_button_container">
            <button
              className="btn cus-seconday-bg-btn top-btn m2"
              onClick={handleDownloadCsv}
              disabled={loader || productsListStatus === "pending" || productsListStatus === "failed" || (productsListStatus === "success" && productsList.length === 0)}
            >
              Download CSV
            </button>

            {props.productType !== "allProducts" && checkPermission(returnsManagement, products, permssionCreate, featureSubmodulePermission, props.employeePermissions) && (
              <Button className="cus-seconday-bg-btn top-btn" onClick={() => handleCreateProduct()}>
                  <i className="fa fa-plus" aria-hidden="true"></i> Create Return
              </Button>
            )}
            {props.productType === "Product" && (
              <Button
                className="cus-seconday-bg-btn top-btn"
                onClick={() => { setTaskContext(null); setShowAddTaskModal(true); }}
              >
                <i className="fa fa-plus" aria-hidden="true"></i> Create New Task
              </Button>
            )}
            {props.productType !== "Product" && (
              <button
                className="btn cus-seconday-bg-btn top-btn m2"
                onClick={() => handleFilterToogle("showFilter", !filterValue.showFilter)}
              >
                Filter
              </button>
            )}
            {props.productType === "Product" && (
              <button
                className="btn cus-primary-transparent-btn top-btn"
                onClick={handleBackNavigation}
              >
                Back
              </button>)}
          </div>
        </div>
        {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}
        <div className={
          filterValue.showSearch
            ? "filterContainer show searchBox mb-2"
            : "filterContainer searchBox mb-2"
        }
        >
          <div className="searchInputBox">
            <input
              value={filterValue.searchTxt}
              onBlur={handleBlur}
              autoFocus
              onKeyDown={handleEnterClick}
              onChange={(e) => handleFilterToogle("searchTxt", e.target.value)}
              className="form-control"
              placeholder={props?.productType === "Product" ? "Search Company, Seller, Seller Code, Item Name, Tracking Number, STE Code, Warehouse, SKU or Storage Id" : "Search by Product Name, SKU, RMA Code, Id, Package Tracking Id, External Platform Product ID"}
            />
          </div>
          <button
            className="btn cus-seconday-bg-btn ml-2 searchBtn"
            onClick={(e) => handleSearchFilter(e, "search")}
          >
            <i className="fa fa-search" aria-hidden="true"></i> Search
          </button>
          <button
            disabled={!filterValue.searchTxt}
            className="btn cus-primary-transparent-btn ml-2 clearbtn"
            onClick={(e) => handleSearchFilter(e, "clear")}
          >
            Clear Search
          </button>
        </div>
        {filterValue.showFilter && !trackingNumber &&
          <FilterProduct
            handleReset={resetPagination}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            setLoader={setLoader}
            sellerList={sellerList}
            setSellerList={setSellerList}
            allSellers={allSellers}
            setAllSellers={setAllSellers}
            filterType={props.productType}
          />
        }
        <div className="main_content cus-page-content-sec zIndex1">
          <div className="main_content_table_history">
            <div className="tableFixHead incomingTbl">
              <Table className={`tableWide table-height cus-left-right-col-layout ${loader ? "disableTble" : ""}`}>
                <thead>
                  <tr>

                    <th width="5%">Thumbnail</th>
                    {UserValue?.Value?.roleName !== 'Seller' && props.productType === "Product" && (
                      
                      <th width="10%">
                        <button
                          className={handleSortingClass('companySellerName')}
                          onClick={(e) => handleSortingCoulmn(e, "companySellerName")}
                        >
                          Company / Seller Name {" "}
                          <i
                            className={handleSortingClass('companySellerName', true)}
                            aria-hidden="true"
                          ></i>
                        </button>
                      </th>
                    )}
                    {props.productType === "Product" && (
                      <th width="10%">Tracking Number</th>
                    )}
                    {props.productType === "Product" && (
                      <th width="10%">
                        <button
                          className={handleSortingClass('status')}
                          onClick={(e) => handleSortingCoulmn(e, "status")}
                        >
                          Status {" "}
                          <i
                            className={handleSortingClass('status', true)}
                            aria-hidden="true"
                          ></i>
                        </button>
                      </th>
                    )}
                    {props.productType === "Product" && (
                      <th width="10%">
                        <button
                          className={handleSortingClass('status')}
                          onClick={(e) => handleSortingCoulmn(e, "billingStatus")}
                        >
                          Billing Status {" "}
                          <i
                            className={handleSortingClass('billingStatus', true)}
                            aria-hidden="true"
                          ></i>
                        </button>
                      </th>
                    )}
                    {props.productType === "Product" && (
                      <th width="10%">
                        <button
                          className={handleSortingClass('processingDate')}
                          onClick={(e) => handleSortingCoulmn(e, "processingDate")}
                        >
                          Processing Date {" "}
                          <i
                            className={handleSortingClass('processingDate', true)}
                            aria-hidden="true"
                          ></i>
                        </button>
                      </th>
                    )}
                    <th width="10%">
                      <button
                        className={handleSortingClass('sku')}
                        onClick={(e) => handleSortingCoulmn(e, "sku")}
                      >
                        SKU {" "}
                        <i
                          className={handleSortingClass('sku', true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>

                    <th width="8%">
                      <button
                        className={handleSortingClass('itemname')}
                        onClick={(e) => handleSortingCoulmn(e, "itemname")}
                        id="itemname"
                      >
                        Name {" "}
                        <i
                          className={handleSortingClass('itemname', true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th width="8%">
                      Return Product Type
                    </th>

                    {props.productType === "Product" && (
                      <th width="10%">
                        <button
                          className={handleSortingClass('warehouse')}
                          onClick={(e) => handleSortingCoulmn(e, "warehouse")}
                          id="warehouse"
                        >
                          Quantity {" "}
                          <i
                            className={handleSortingClass('warehouse', true)}
                            aria-hidden="true"
                          ></i>
                        </button>
                      </th>
                    )}
                    {props.productType === "allProducts" && (
                      <th width="10%">
                        <button
                          className={handleSortingClass('qty')}
                          onClick={(e) => handleSortingCoulmn(e, "qty")}
                        >
                          Available Qty {" "}
                          <i
                            className={handleSortingClass('qty', true)}
                            aria-hidden="true"
                          ></i>
                        </button>
                      </th>
                    )}
                    {props.productType === "Product" && (
                      <th width="10%">
                        <button
                          className={handleSortingClass('condition')}
                          onClick={(e) => handleSortingCoulmn(e, "condition")}
                          id="condition"
                        >
                          Item Condition {" "}
                          <i
                            className={handleSortingClass('condition', true)}
                            aria-hidden="true"
                          ></i>
                        </button>
                      </th>
                    )}
                    <th width="15%" className="sticky">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {productsList && productsList.length > 0 && (
                    <>
                      {productsList.map((item, index) => (
                        <tr key={item.id}>
                          <td>
                            {item?.thumbnailUrl ? (
                              <button
                                className="thumbImg sortBtn"
                                onClick={() => {
                                  setSelectedRecord(item);
                                  setShowHideImageModal(!showHideImageModal);
                                }}
                              >
                                <img src={item.thumbnailUrl} alt="" />
                              </button>
                            ) : (
                              <></>
                            )}
                          </td>
                          {UserValue?.Value?.roleName !== 'Seller' && props.productType === "Product" && (
                            <td className="companySellerCol">{item.companySellerName}</td>
                          )}
                          {props.productType === "Product" && (
                            <td className="companySellerCol">
                              <button
                                className="seller-modal sortBtn alignLeft"
                                title="Click to navigate back to Packages"
                                onClick={() => handlePackagePageNavigation(item)}
                              >
                                {item.trackingNo}
                              </button>
                            </td>
                          )}
                          {props.productType === "Product" && (
                            <td>
                              <span className='statusTd capitalizeText'>
                                <span className={getStatusClass(item.status)}>{item.status}</span>
                              </span>
                            </td>
                          )}
                          {props.productType === "Product" && (
                            <td>
                              {item.billingStatus}
                            </td>
                          )}
                          {props.productType === "Product" && (
                            <td>
                              {item.processingDate ? moment(item.processingDate).format(
                                "MM-DD-YYYY"
                              ) : '-'}
                            </td>
                          )}
                          <td>{item.sku}</td>
                          <td className="taskTitle">{item.itemName}</td>
                          <td className="taskTitle">{item.productType}</td>

                          {props.productType === "Product" && (
                            <td>
                              {item.totalQuantity === 0 ? item.quantity : Number(item.totalQuantity)}
                              <>
                                <i className="fa fa-info-circle ml-2" aria-hidden="true" id={item.id}></i>
                                <WmsTooltip
                                  anchorId={item.id}
                                  id={item.id}
                                  place="left"
                                  data-tooltip-html={true}
                                  className="tooltipWidth"
                                >
                                  <div>Available Qty (Returns) = {item.quantity}</div>
                                  <div>Available Qty (Inventory) = {item.totalQuantity === 0 ? 0 : Number(item.totalQuantity - item.quantity)}</div>
                                </WmsTooltip>
                              </>
                            </td>
                          )}
                          {props.productType === "allProducts" && (
                            <td>
                              {item.totalQuantity === 0 ? item.quantity : Number(item.totalQuantity)}
                              <>
                                <i className="fa fa-info-circle ml-2" aria-hidden="true" id={item.id}></i>
                                <WmsTooltip
                                  anchorId={item.id}
                                  id={item.id}
                                  place="left"
                                  data-tooltip-html={true}
                                  className="tooltipWidth"
                                >
                                  <div>Available Qty (Returns) = {item.quantity}</div>
                                  <div>Available Qty (Inventory) = {item.totalQuantity === 0 ? 0 : Number(item.totalQuantity - item.quantity)}</div>
                                </WmsTooltip>
                              </>
                            </td>
                          )}
                          {props.productType === "Product" && (
                            <td>{item.condition}</td>
                          )}
                          <td className="flex-mob-res sticky">
                            {checkPermission(orderManagement, shipmentModule, permssionCreate, featureSubmodulePermission, employeePermissions) && (
                              <ActionItems
                                type={"icon"}
                                item={item}
                                handleAction={() =>
                                  handleAddToCartAction(item)
                                }
                                iconContent="Add To Cart"
                                iconType="fa fa-cart-plus"
                              />
                            )}
                            {props.productType === "Product" && (
                              <ActionItems
                                type={"icon"}
                                item={item}
                                icon={"addTask"}
                                iconType={"fa fa-tasks"}
                                iconContent={"Create Task"}
                                handleAction={() => handleOpenCreateTaskForProduct(item)}
                              />
                            )}
                            {props.productType === "allProducts" ?
                              checkPermission(returnsManagement, SUBF_PRODUCTLISTING, permssionView, featureSubmodulePermission, props.employeePermissions) && (
                                <ActionItems
                                  type={"View"}
                                  item={item}
                                  handleAction={() =>
                                    handleViewRow(item)
                                  }
                                />
                              ) : checkPermission(returnsManagement, products, permssionView, featureSubmodulePermission, props.employeePermissions) && (
                                <ActionItems
                                  type={"View"}
                                  item={item}
                                  handleAction={() =>
                                    handleViewRow(item)
                                  }
                                />
                              )}
                            {props.productType === "allProducts" ?
                              checkPermission(returnsManagement, SUBF_PRODUCTLISTING, permssionEdit, featureSubmodulePermission, props.employeePermissions) && (
                                <ActionItems
                                  type={"Edit"}
                                  item={item}
                                  handleAction={() =>
                                    handleEditRow(item)
                                  }
                                />
                              ) : checkPermission(returnsManagement, products, permssionEdit, featureSubmodulePermission, props.employeePermissions) && (
                                <ActionItems
                                  type={"Edit"}
                                  item={item}
                                  handleAction={() =>
                                    handleEditRow(item)
                                  }
                                />
                              )}
                            <ActionItems
                              type={"History"}
                              item={item}
                              handleAction={() => {
                                props.productType === "Product"
                                  ? handleHistoryPage(item)
                                  : handleAllProductHistoryPage(item)
                              }
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                  {productsListStatus === "success" && productsList.length === 0 && (
                    renderTableRow(12, 'No record found')
                  )}
                  {productsListStatus !== "success" && renderTableRow(12, 'No record found')}
                </tbody>
              </Table>
            </div>
          </div>
          
          {productsListPageInfo?.TotalRecords > 0 && (
            <BatchPagination
              gridData={allProduct}
              numberOfPage={filterValue.pageSize}
              numOfPage={numOfPage}
              loader={loader}
              currentPage={filterValue.pageIndex}
              totalPages={Math.ceil(productsListPageInfo?.TotalRecords / filterValue.pageSize)}
              totalRecords={productsListPageInfo?.TotalRecords}
              setCurrentPage={(value) => setFilterValue({ ...filterValue, pageIndex: value })}
              setNumberOfPage={(value) => setFilterValue({ ...filterValue, pageSize: value, pageIndex: 1 })}
            />
          )}

          <ViewImage
            selectedRecord={selectedRecord}
            setShowHideImageModal={setShowHideImageModal}
            showHideImageModal={showHideImageModal}
            title={"Product Image"}
          />
          <AddTaskModal
            show={showAddTaskModal}
            handleCancel={() => { setShowAddTaskModal(false); setTaskContext(null); }}
            productContext={taskContext || {}}
            onCreated={() => { setShowAddTaskModal(false); setTaskContext(null); }}
          />
        </div>
      </div>
    </main>
  );
};

ProductList.propTypes = {
  productType: PropTypes.string,
  employeePermissions: PropTypes.array,
};

export default ProductList;